import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { programClient } from '../client/programClient';


export const useEnrollments = () => {
  const { data: { data }, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getEnrollments],
    queryFn: () => programClient.getEnrollments(),
    retry: false,
  });

  return {
    ...rest,
    enrollments: data.results || [],
  };
};
